import React, { useContext, useState } from "react";
import { isEmpty, get } from "lodash";
import {
  PayrollTreeStructure,
  FormLeaveGuard,
  SliderPanel,
} from "../../../../../components";
import { useHistory } from "react-router-dom";
import { Modal, Button } from "react-bootstrap";
import { ROUTES, getPathWithParam, usCurrency } from "../../../../../utils";
import {
  confirmFunds,
  getAwaitingFundingDetailsByClassification,
  getAwaitingFundingDetailsByPlan,
  retrieveBankDetails,
} from "../../../../../services";
import { useDeepEffect, useRequest } from "../../../../../abstracts";
import {
  faExclamationTriangle,
  faCheckCircle,
} from "@fortawesome/pro-light-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  managePayrollStore,
  setManagePayrollToastInfo,
} from "../../../../../contexts";
import PayrollFundingDetails from "./PayrollFundingDetails";
import ManualOverridePopupCard from "./FundingDetails/ManualOverridePopupCard";
import ConfirmationPopUpCard from "./FundingDetails/ConfirmationPopupCard";

const PayrollFundingConfirmation = ({
  retrigger = true,
  data,
  toggle,
  fileId,
  setToggle,
  payrollId,
  isClassification = false,
  classificationCodeId,
  classificationType,
  setFundModalOpen,
  isFundModalOpen,
  triggerSlider,
  setTriggerSlider,
  setViewByDisabled,
  retriggerCount,
  setRetriggerCount,
}) => {
  const history = useHistory();
  const { dispatch } = useContext(managePayrollStore);
  const [planFund, setPlanFund] = useState([]);
  const [classificationFund, setClassificationFund] = useState([]);
  const [isForfeiture, setIsForfeiture] = useState(false);
  const [isACHDebit, setIsACHDebit] = useState(false);
  const [show, setShow] = useState(false);
  const [bankTotal, setBankTotal] = useState(0);
  const [forfeitureTotal, setForfeitureTotal] = useState(0);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [msg, setMsg] = useState();
  const [showDirtyCheckModal, setShowDirtyCheckModal] = useState(false);
  const achTotal = isClassification
    ? get(classificationFund, "achDebitFundings[0].amount", 0)
    : get(planFund, "achDebitFundings[0].amount", 0);
  const [confirmFund, setConfirmFund] = useState(false);
  const [confirmManualOverrideFund, setConfirmManualOverrideFund] = useState(
    false
  );
  const [achBankName, setAchBankName] = useState();
  const [forfeitureBankName, setForfeitureBankName] = useState();

  const [flag, setFlag] = useState(false);
  useDeepEffect(() => {
    setMsg(
      isForfeiture && isACHDebit
        ? `forfeiture and ACH Debit - ${usCurrency(forfeitureTotal + achTotal)}`
        : isForfeiture
        ? `forfeiture ${usCurrency(forfeitureTotal)}`
        : isACHDebit
        ? `ACH Debit - ${usCurrency(achTotal)}`
        : null
    );
  }, [isForfeiture, isACHDebit]);
  useDeepEffect(() => {
    if (isClassification)
      getAwaitingFundingDetailsByClassification(
        fileId,
        data.planId,
        classificationCodeId
      ).then((res) => setClassificationFund(res));
    else
      getAwaitingFundingDetailsByPlan(fileId, data.planId).then((res) => {
        setAchBankName(res?.achDebitFundings);
        setForfeitureBankName(res?.forfeitureFundings);
        setPlanFund(res);
      });
  }, []);

  const forfeitureBank = forfeitureBankName?.map((x) => x.forfeitureName);
  const achBank = achBankName?.map((x) => x.bankName);
  const bankNameDetails =
    isForfeiture && isACHDebit
      ? forfeitureBank?.concat(" and ", achBank)
      : isForfeiture
      ? forfeitureBankName?.map((x) => x.forfeitureName)
      : isACHDebit
      ? achBankName?.map((x) => x.bankName)
      : "";

  useDeepEffect(() => {
    if (!isClassification) {
      let bankFund = !isEmpty(planFund)
        ? planFund.bankFundings.map((_) => (_.bankFund !== "" ? _.bankFund : 0))
        : [];
      let forfeitureFund = !isEmpty(planFund)
        ? planFund.forfeitureFundings.map((_) =>
            _.forfeitureFund !== "" ? _.forfeitureFund : 0
          )
        : [];
      setBankTotal(
        bankFund.reduce((accumulator, currentValue) => {
          return accumulator + currentValue;
        }, 0)
      );
      setForfeitureTotal(
        forfeitureFund.reduce((accumulator, currentValue) => {
          return accumulator + currentValue;
        }, 0)
      );
    } else {
      let bankFund = !isEmpty(classificationFund)
        ? classificationFund.bankFundings.map((_) =>
            _.bankFund !== "" ? _.bankFund : 0
          )
        : [];
      let forfeitureFund = !isEmpty(classificationFund)
        ? classificationFund.forfeitureFundings.map((_) =>
            _.forfeitureFund !== "" ? _.forfeitureFund : 0
          )
        : [];
      setBankTotal(
        bankFund.reduce((accumulator, currentValue) => {
          return accumulator + currentValue;
        }, 0)
      );
      setForfeitureTotal(
        forfeitureFund.reduce((accumulator, currentValue) => {
          return accumulator + currentValue;
        }, 0)
      );
    }
  }, [classificationFund, planFund]);

  const onFormToggle = () => {
    if (isForfeiture || isACHDebit || (isForfeiture && isACHDebit)) {
      setShowDirtyCheckModal(true);
    } else {
      setFundModalOpen(!isFundModalOpen);
    }
  };

  const handleConfirmClick = () => {
    setFundModalOpen(!isFundModalOpen);
  };

  const handleCancelClick = () => {
    setShowDirtyCheckModal(false);
  };

  const onSubmit = () => {
    let updatedValues = {
      fileId: fileId,
      payrollFundingId: isClassification
        ? classificationFund.payrollFundingId
        : planFund.payrollFundingId,
      fundingType: classificationType,
      isForfeiture: isForfeiture,
      isACHDebit: isACHDebit,
    };
    confirmFunds(updatedValues)
      .then((res) => {
        if (res.isSuccessfull) {
          if (res.isFunded) {
            dispatch(
              setManagePayrollToastInfo({
                showToast: true,
                toastMessage: "File has been funded successfully",
              })
            );
            history.push(
              getPathWithParam({
                path: ROUTES.PAYROLL,
              })
            );
          }
          setToggle(!toggle);
          setIsModalOpen(!isModalOpen);
          setFundModalOpen(!isFundModalOpen);
        }
      })
      .catch((error) => {
        //error
      });
  };

  const triggerSliderFunction = () => {
    setRetriggerCount(retriggerCount + 1);
    setTriggerSlider(true);
  };

  const func = async () => {
    setFlag(true);

    await setTimeout(() => {
      setFlag(false);
    }, 3000);
    onSubmit();
    setConfirmFund(false);
  };

  return (
    <div>
      <div className="d-flex justify-content-between align-baseline">
        <div className="plan-heading font-weight-500">Confirm Funds</div>
        {confirmFund == false && (
          <div className="d-flex mt-10">
            <Button
              variant={"secondary"}
              onClick={() => {
                onFormToggle();
              }}
            >
              Cancel
            </Button>
            <div className={"ml-3"}>
              <Button
                variant={"primary"}
                disabled={!isACHDebit && !isForfeiture}
                onClick={() => {
                  setIsModalOpen(!isModalOpen);
                  setConfirmFund(true);
                }}
              >
                Confirm Funds
              </Button>
            </div>
          </div>
        )}
      </div>

      {confirmFund && (
        <ManualOverridePopupCard
          flag={flag}
          setFlag={setFlag}
          confirmFund={confirmFund}
          setConfirmFund={setConfirmFund}
          confirmManualOverrideFund={confirmManualOverrideFund}
          setConfirmManualOverrideFund={setConfirmManualOverrideFund}
          onSubmit={onSubmit}
          func={func}
          msg={msg}
          achTotal={achTotal}
          setMsg={setMsg}
          bankNameDetails={bankNameDetails}
        />
      )}

      {
        flag && <ConfirmationPopUpCard setFlag={setFlag} />
        //flag && <div style={{width: '200px', height: "200px", background:"red"}}></div>
      }

      <div className="border-top" />
      <div className={"black-text ft-14 font-weight-500 pb-2"}>
        {data.planName}
      </div>
      <PayrollTreeStructure
        data={isClassification ? classificationFund : planFund}
        isForfeiture={isForfeiture}
        setIsForfeiture={setIsForfeiture}
        isACHDebit={isACHDebit}
        setIsACHDebit={setIsACHDebit}
        bankTotal={bankTotal}
        forfeitureTotal={forfeitureTotal}
        retriggerCount={retriggerCount}
        setRetriggerCount={setRetriggerCount}
      />
      {!isEmpty(achBankName) && (
        <button
          onClick={() => {
            triggerSliderFunction();
          }}
          className="ft-12 primary-small"
          style={{
            textDecoration: "underline",
            paddingLeft: "80%",
            cursor: "pointer",
            whiteSpace: "nowrap",
            border: "none",
            backgroundColor: "white",
          }}
        >
          Retrigger ACH Debit
        </button>
      )}
      {/* <div onClick={() => triggerSliderFunction()} className="ft-12" style={{ color: "#004DCB", paddingLeft: "38rem", textDecoration: "underline" }}>Retrigger ACH Debit</div> */}
      <div className="border-top-dashed" />
      <div className="d-flex justify-content-start black-text font-weight-500 ft-14">
        <div style={{ width: "80%" }}>Total amount</div>
        <div style={{ width: "20%" }}>
          {usCurrency(
            isClassification
              ? classificationFund.totalFundingAmount
              : planFund.totalFundingAmount
          )}
        </div>
      </div>

      {/* <Modal show={isModalOpen} size="smd">
        <Modal.Body>
          <div className="d-flex">
            <div className="pd-15">
              <FontAwesomeIcon
                icon={faExclamationTriangle}
                color="orange"
                size="3x"
                className="mt-3"
              />
            </div>
            <div className="remove-text">
              <h4>Manual Override ?</h4>
              <p>
                You are confirming fund received via <b>{msg}</b>. Do you want
                to continue?
              </p>
              <br />
              <Button
                variant="secondary"
                onClick={() => setIsModalOpen(!isModalOpen)}
                className="ml-5 mr-3"
              >
                No
              </Button>
              <Button
                variant="primary"
                style={{
                  backgroundColor: "orange",
                  color: "#fff",
                  border: "2px solid orange",
                }}
                onClick={() => onSubmit()}
              >
                Yes
              </Button>
            </div>
          </div>
        </Modal.Body>
      </Modal> */}
      <FormLeaveGuard
        showModal={showDirtyCheckModal}
        handleConfirmClick={handleConfirmClick}
        handleCancelClick={handleCancelClick}
      />
    </div>
  );
};

export default PayrollFundingConfirmation;

{
  /* <div className="w-100" style={{
  border: "1px solid none",
  height: "50px",
  borderRadius: "5px",
  background: "linear-gradient(0deg, rgba(178, 205, 186, 0.3), rgba(178, 205, 186, 0.3)), #FEFEFE"
}}>
  <div>
    <FontAwesomeIcon icon={faCheckCircle}
      style={{ margin: "15px" }}
      color="green"
      size="lg" />
    <span style={{
      position: "absolute", marginTop: "15px",
      fontWeight: 500,
      fontSize: "18px",
      lineHeight: "24px",
    }}>ACH Debit - Manually Confirmed</span>
  </div>

</div> */
}
